export default __webpack_public_path__ + "static/media/employees.84254e48.svg";